import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuestionService = sdk.getService('QuestionService');

export const useQuestionQuizzes = (questionId?: string) => {
  const queryKey = ['question', questionId, 'quizzes'];

  const { data, isPending } = useQuery({
    queryKey,
    queryFn: () => QuestionService.getQuestionQuizzes(questionId),
    enabled: !!questionId
  });

  return { quizzes: data, isPending };
};
